import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'PMs'
const DB_VERSION = 2

const STORES_DEF = [
    { name: 'headers', keyPath: 'id' },
    { name: 'structs', keyPath: 'id' }
]

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, STORES_DEF)

const initDb = () => {
    return dbInstance.init()
}

// --- headers store ---

const agregarHeader = (data, database) => {
    return dbInstance.add('headers', data, database)
}

const obtenerHeader = (clave, database) => {
    return dbInstance.get('headers', Number(clave), database)
}

const actualizarHeader = (data, database) => {
    return dbInstance.put('headers', data, database)
}

const eliminarHeader = (clave, database) => {
    return dbInstance.delete('headers', clave, database)
}

const consultarHeaders = (database) => {
    return dbInstance.getAll('headers', database)
}

// --- structs store ---

const agregarStruct = (data, database) => {
    return dbInstance.add('structs', data, database)
}

const obtenerStruct = (clave, database) => {
    return dbInstance.get('structs', Number(clave), database)
}

const actualizarStruct = (data, database) => {
    return dbInstance.put('structs', data, database)
}

const eliminarStruct = (clave, database) => {
    return dbInstance.delete('structs', clave, database)
}

const consultarStructs = (database) => {
    return dbInstance.getAll('structs', database)
}

export default {
    initDb,
    agregarHeader,
    obtenerHeader,
    actualizarHeader,
    eliminarHeader,
    consultarHeaders,
    agregarStruct,
    obtenerStruct,
    actualizarStruct,
    eliminarStruct,
    consultarStructs
}
